// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XeE_C","col":"styles_col__17nrq"};